import { Center, Spinner, Text } from "@chakra-ui/react"
import { createFileRoute } from "@tanstack/react-router"
import { useEffect } from "react"

import useAuth from "@/hooks/useAuth"

export const Route = createFileRoute("/logout")({
  component: Logout,
})

function Logout() {
  const { logout } = useAuth()

  useEffect(() => {
    logout()
  }, [logout])

  return (
    <Center minH="100vh" flexDirection="column" gap={3} p={6}>
      <Spinner size="lg" />
      <Text fontSize="lg" fontWeight="semibold">
        Signing you out...
      </Text>
    </Center>
  )
}

export default Logout
